import { ChangeEvent } from 'react';
import { StyledSelect } from '~/components/dropdowns/select.style';

interface HouseholdOccupancySelectComponentProps {
  onChange: (value: string, e: ChangeEvent<HTMLSelectElement>) => void;
  value: number | string;
  options: {
    disabled?: boolean;
    selected?: boolean;
    text: string;
    value?: number | string;
  }[];
}
export const HouseholdOccupancySelectComponent = ({
  onChange,
  value,
  options,
}: HouseholdOccupancySelectComponentProps) => {
  return (
    <StyledSelect
      disabled={false}
      id="occupancy-select"
      label="Select your household occupancy"
      required
      loading={false}
      minHeight="auto"
      name="houseOccupancy"
      onChange={onChange}
      options={options}
      value={value}
      withEmptyPlaceholder={false}
      placeholder="Please select an option"
    />
  );
};
